import ConfigManager from "@/config/ConfigManager";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    apiSendMessage: function (params) {
        let url = ConfigManager.getApiModuleUrl() + "/line/user_send_message_text"
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },
}